import { render, staticRenderFns } from "./DetailListTableAll.vue?vue&type=template&id=4287fe68&scoped=true&"
import script from "./DetailListTableAll.vue?vue&type=script&lang=js&"
export * from "./DetailListTableAll.vue?vue&type=script&lang=js&"
import style0 from "./DetailListTableAll.vue?vue&type=style&index=0&id=4287fe68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4287fe68",
  null
  
)

export default component.exports